var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","fill-height":""}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('h6',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('views.browserNotSupported.message')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }